import axios from 'axios';
import Cookie from '../components/pages/Cookie/Cookie';
import { getJaecooSiteLang } from './cookie';

// create an axios instance
const service = axios.create({
  baseURL: process.env.REACT_APP_SITECORE_API_HOST, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60 * 1000 * 5, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // 从cookie中获取语言设置
    const lang = getJaecooSiteLang() || 'en';
    console.log(lang, 'lang from cookie');
    config.headers.site = 'be-site';
    config.headers.lang = lang;
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    let res = null;
    try {
      res = response.data;
      return res;
    } catch (e) {
      return Promise.reject(response);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
